module.exports = __webpack_public_path__ + "static/img/19.d703634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/19.png
// module id = lM1w
// module chunks = 1